import { styled } from '@mui/material';
import Box from 'shell/components/Box';
import CircularProgress from 'shell/components/CircularProgress';
import Stack from 'shell/components/Stack';

const Loading = (props) => {
    return (
        <CustomBox {...props}>
            <CustomStack alignItems={'center'} justifyContent={'center'}>
                <CircularProgress aria-label={'loading'} />
            </CustomStack>
        </CustomBox>
    );
};

const CustomBox = styled(Box)(() => {
    return {
        position: 'relative',
        width: '100%',
        height: '100%',
    };
});

const CustomStack = styled(Stack)(() => {
    return {
        position: 'absolute',
        top: '45%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    };
});

export default Loading;
